define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-tv-layout-cast-characters';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvLayoutCastContentSubheaderCls, 'animate__slideInDown', 'tv-layout-cast-characters', {});

                $(view.publicVars.cssId.anim.tvLayoutCastBoxItemCls).each(function (key, item) {
                    const id = container.getData($(item)[0], 'id');
                    scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.tvLayoutCastBoxItemCls .substr(1) + id, 'animate__zoomIn',
                        'tv-layout-cast-characters', {});
                });

                $(view.publicVars.cssId.anim.tvLayoutCastBoxItemImageCharacterCls).each(function (key, item) {
                    const id = container.getData($(item)[0], 'id');
                    scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.tvLayoutCastBoxItemImageCharacterCls .substr(1) + id, 'animate__rotateInDownRight',
                        'tv-layout-cast-characters', {});
                });

                $(view.publicVars.cssId.anim.tvLayoutCastBoxItemImageCastCls).each(function (key, item) {
                    const id = container.getData($(item)[0], 'id');
                    scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.tvLayoutCastBoxItemImageCastCls .substr(1) + id, 'animate__rotateInDownLeft',
                        'tv-layout-cast-characters', {});
                });
            };

            view.bind = function () {

            };

            view.methods = {
                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */

            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });